export const API_ERROR = "api_failed";

export const PURCHASE_ORDER_LIST = "purchase_Ordert_List";
export const PURCHASE_ORDER_LIST_SUCCESS = "purchase_Ordert_List_Successful";

export const PURCHASE_ORDER_ROW_DATA = "purchase_Ordert_row_data";
export const PURCHASE_ORDER_ROW_DATA_SUCCESS =
	"purchase_Ordert_row_data_Successful";

export const TOGGLE_ITEM_MENU = "po_toggle_item_menu";

export const SET_PARAMS = "po_set_params";
export const FILTER_INPUT_CHANGEVALUE = "po_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "po_Filter_Select_ChangeValue";
export const LIST_LAYOUT = "po_list_layout";
export const PURCHASEREQUEST_ROW_DATA = "purchaserequest_Row_Data";
export const FILTERS_SHOW_RIGHT_SIDEBAR = "PO_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "PO_filter_hide_right_sidebar";
export const CLEAR_FILTER = "PO_clear_filter";

export const PDF_DOWNNLOAD = "PO_PDF_Download";

export const MR_CODE_DETAILS = "PO_mr_code_details";
export const MR_CODE_DETAILS_SUCCESS = "PO_mr_code_details_Successful";

export const PI_CODE_DETAILS = "po_pi_code_details";
export const PI_CODE_DETAILS_SUCCESS = "po_pi_code_details_Successful";

export const PO_ITEM_ACKNOWLEDGE_OPEN = "PO_POIacknowledge_open";
export const PO_CLOSE_MODAL_OPEN = "PO_CLOSE_MODAL_OPEN";
export const PO_CLOSE_MODAL_CLOSE = "PO_CLOSE_MODAL_CLOSE";
export const PO_ITEM_ACKNOWLEDGE_CLOSE = "PO_POIacknowledge_close";

export const PO_ITEM_INPUT_CHANGEVALUE = "PO_POIacknowledge_inputchangeValues";
export const PO_CLOSE_DESCRIPTION = "PO_CLOSE_DESCRIPTION";

export const PO_ITEM_ACKNOWLEDGE = "PO_POIacknowledge_submit";

export const PURCHASE_ORDER_CLOSE = "purchase_order_close";

export const PURCHASE_ORDER_FOUCS_POST = "PoFoucsPost";
export const TOGGLE_EDIT = "TOGGLE_EDIT";
export const TOGGLE_EDIT_WITH_VALUE = "TOGGLE_EDIT_WITH_VALUE";
export const APPROVE_EDIT_WITH_VALUE = "APPROVE_EDIT_WITH_VALUE";

export const HANDLE_BASE_PRICE = "HANDLE_BASE_PRICE";
export const ORDER_DISC_PERCENT_CHANGEVALUE = "ORDER_desc_percent_ChangeValue";
export const ITEM_GROSS_VAL_CHANGEVALUE = "ITEM_GROSS_VAL_CHANGEVALUE";
export const ORDER_BASEPRICE_CHANGEVALUE = "ORDER_BASEPRICE_CHANGEVALUE";
export const ORDER_TAXTYPE_CHANGEVALUE = "ORDER_TAXTYPE_CHANGEVALUE";
export const ORDER_TAX_CHANGEVALUE = "ORDER_TAX_CHANGEVALUE";
export const SUBMIT_EDIT_ORDER = "SUBMIT_EDIT_ORDER";
export const SUBMIT_EDIT_ORDER_SUCCESSFULL = "SUBMIT_EDIT_ORDER_SUCCESSFULL";
export const VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE =
	"VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE";
export const VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE =
	"VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE";
export const ITEM_TIME_LINE = "po_item_time_line";
export const PO_HISTORY = "PO_HISTORY";
export const PO_HISTORY_SUCCESS = "PO_HISTORY_SUCCESS";

export const PO_AUTHORIZATION = "PO_AUTHORIZATION";
export const PO_AUTHORIZATION_SUCCESS = "PO_AUTHORIZATION_SUCCESS";